/**
 * @file step menu
 * @author zhaomiaoyuan
 */
import React, {useEffect} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import './index.less';
const StepsMenu = (props) => {
    const {
        data=[],
        curStep
    } = props;

    useEffect(() => {
    }, []);
    return (
        <div className="steps">
            <ul className="steps-list">
                {data.map((item, index) => {
                    return (
                        <li className="card-item" key={index}>
                            <div className="card-item-img">
                                <img width={64} src={curStep >= index + 1 ? item.img : item.imgNormal} />
                            </div>
                            <div className="card-item-content">
                                <h2 className={curStep >= index + 1 ? '' : 'normal'}>{item.title}</h2>
                                {index < data.length - 1 && <i></i>}
                                <p>{item.content}</p>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

StepsMenu.propTypes = {
    data: PropTypes.array,
    curStep: PropTypes.number,
    location: PropTypes.object,
    history: PropTypes.object
};

export default withRouter(StepsMenu);
